function formatString(string, ...args) {
    return string.replace(/{(\d+)}/g, function(match, number) {
      number = parseInt(number) - 1
      return args.length > number ? args[number] : match
    })
}

const browserLanguage = window.navigator.userLanguage || window.navigator.language

function matchBrowserLanguage(lang)
{
    if (lang === browserLanguage) {
        return true
    }
    if (browserLanguage.split(/[_\-]/)[0] === lang) {
        return true
    }
    return false
}

class Language
{
    constructor(code, name, browserLanguages, translation, fallbackLanguage)
    {
        this.code = code
        this.name = name
        this.browserLanguages = browserLanguages
        this.translation = translation
        this.fallbackLanguage = fallbackLanguage
    }

    matchBrowser()
    {
        if (this.browserLanguages === null) {
            return false
        }
        for (var i = 0; i < this.browserLanguages.length; i++) {
            if (matchBrowserLanguage(this.browserLanguages[i])){
                return true
            }
        }
        return false
    }

    getName()
    {
        return this.name
    }

    getCode()
    {
        return this.code
    }

    tr(key, ...args)
    {
        return formatString(this.getKeyTemplate(key), ...args)
    }

    getKeyTemplate(key)
    {
        if (key in this.translation) {
            return this.translation[key]
        }
        if (this.fallbackLanguage !== null) {
            return this.fallbackLanguage.getKeyTemplate(key)
        }

        return "!!!" + key + "!!!"
    }
}

export default Language
